import { type VirtualRewardProps } from "@hg/activity-utils"
import cls from "classnames"
import { useCallback, useMemo, useState } from "react"

import { ModalContent } from "@/components/Modal"
import StrokeText from "@/components/StrokeText"
import { i18n } from "@/i18n"
import { RECALL_REWARD_MAP } from "@/topics/Recall/const/reward"
import { getItem } from "@/utils/gameAssets"
import { MAIN_REWARD_MAP } from "../const"
import { RuleModal } from "./Rule"

import styles from "./index.module.scss"

interface Props extends VirtualRewardProps {
    onClickRule?: () => void
}

export const VirtualReward: React.FC<Props> = (props) => {
    const { reward, onClose, onClickRule } = props

    const [ruleOpen, setRuleOpen] = useState(false)

    const src = useMemo(
        () => reward.src || getItem(reward.key),
        [reward.key, reward.src],
    )

    const amount = useMemo(() => {
        return (
            (reward as any).amount ??
            MAIN_REWARD_MAP[reward.key]?.amount ??
            RECALL_REWARD_MAP[reward.key]?.amount ??
            1
        )
    }, [reward])

    const fontSize = useMemo(() => {
        if (reward.title.length > 12) {
            return 24
        }
        if (reward.title.length > 8) {
            return 32
        }
        if (reward.title.length > 7) {
            return 35
        }
        return 37
    }, [reward.title])

    const handleClickRule = useCallback(() => {
        if (onClickRule) {
            onClickRule()
        } else {
            setRuleOpen(true)
        }
    }, [onClickRule])

    return (
        <ModalContent
            size="medium"
            onCancel={onClose}
            showCancelBtn={false}
            showOkBtn={false}
        >
            <div className={cls(styles.congratulations, styles.medium)} />
            <div className={styles.virtualReward}>
                <div className={styles.imgWrapper}>
                    <img src={src} alt={reward.title} />
                </div>
                <div className={styles.name}>
                    <StrokeText
                        text={`${reward.title}x${amount}`}
                        fontFamily="a한글세상B"
                        fontSize={fontSize}
                        fillColor="#fffbf1"
                        borderWidth={4}
                        borderColor="#614518"
                        offsetY={0}
                        padding={4}
                        className={styles.text}
                    />
                </div>
            </div>
            <button
                type="button"
                className={styles.ruleButton}
                onClick={handleClickRule}
            >
                <StrokeText
                    text={i18n.get("lottery.btn_rule")}
                    fontFamily="a한글세상B"
                    fontSize={27}
                    fillColor="#ffffff"
                    borderWidth={4}
                    borderColor="#564426"
                    offsetY={0}
                    padding={4}
                />
            </button>
            <RuleModal
                open={ruleOpen}
                onConfirm={() => setRuleOpen(false)}
                onClose={() => setRuleOpen(false)}
                loading={false}
                showOkBtn={false}
            />
        </ModalContent>
    )
}
